/**
 * @generated SignedSource<<7746345013e16c344b125b2c601725c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionCountdown_item$data = {
  readonly relevantAuctionLot: {
    readonly endDate: string | null;
    readonly startDate: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionState_item">;
  readonly " $fragmentType": "PdpSharedAuctionCountdown_item";
};
export type PdpSharedAuctionCountdown_item$key = {
  readonly " $data"?: PdpSharedAuctionCountdown_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionCountdown_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionCountdown_item",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionLot(page:\"pdp\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "4d56cc2c2c7b1caf9dc6eb6c1adbf58a";

export default node;
